var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo / Unique") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-/-Unique",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C9.16790158,-2.14540039e-16 10.2054096,0.55828111 10.8602123,1.42253155 C10.2864995,1.97445282 9.93103448,2.74867042 9.93103448,3.60591133 L9.93103448,3.60591133 L9.93103448,12.3940887 C9.93103448,13.2513296 10.2864995,14.0255472 10.8580726,14.5773845 C10.2054096,15.4417189 9.16790158,16 8,16 C6.83209842,16 5.79459039,15.4417189 5.13978767,14.5774684 C5.71350049,14.0255472 6.06896552,13.2513296 6.06896552,12.3940887 L6.06896552,12.3940887 L6.06896552,3.60591133 C6.06896552,2.74867042 5.71350049,1.97445282 5.14192742,1.42261553 C5.79459039,0.55828111 6.83209842,2.14540039e-16 8,0 Z M3.03448276,0.571428571 C3.8531404,0.571428571 4.59608009,0.89561569 5.14192742,1.42261553 C4.68413115,2.02393612 4.4137931,2.77350109 4.4137931,3.5862069 L4.4137931,3.5862069 L4.4137931,12.4137931 C4.4137931,13.2264989 4.68413115,13.9760639 5.13978767,14.5774684 C4.59608009,15.1043843 3.8531404,15.4285714 3.03448276,15.4285714 C1.35858421,15.4285714 2.0523838e-16,14.0699872 0,12.3940887 L0,3.60591133 C-2.0523838e-16,1.93001278 1.35858421,0.571428571 3.03448276,0.571428571 Z M12.9655172,0.571428571 C14.6414158,0.571428571 16,1.93001278 16,3.60591133 L16,12.3940887 C16,14.0699872 14.6414158,15.4285714 12.9655172,15.4285714 C12.1468596,15.4285714 11.4039199,15.1043843 10.8580726,14.5773845 C11.3158689,13.9760639 11.5862069,13.2264989 11.5862069,12.4137931 L11.5862069,12.4137931 L11.5862069,3.5862069 C11.5862069,2.77350109 11.3158689,2.02393612 10.8602123,1.42253155 C11.4039199,0.89561569 12.1468596,0.571428571 12.9655172,0.571428571 Z",
    id: "Logo",
    fill: "#FF4040"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.2a96662391290b52d4f5fef9cc50f72f.svg";
export { ForwardRef as ReactComponent };